exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-tips[data-v-6788464d]{padding-bottom:10px;color:#333}.title-tips span[data-v-6788464d]{margin-right:14px;color:#999}", ""]);

// exports
